<template>
	<div class="wrapper">
		<h5>{{ getText(textQuestion) }}</h5>
		<div class="bar">
			<!-- Range cells -->
			<div
				v-for="number in range"
				:key="number"
				class="cell"
				:class="{
					'cell-left': number == min,
					'cell-right': number == max,
					'cell-highlighted': selected > number,
					'cell-selected': selected == number,
				}"
				:style="{
					background: 'hsl((number-min)/(max-min)*255, 0, 0)',
				}"
				@click="selected = number"
			>
				<!-- <span v-if="selected == number">( {{ number }} )</span> -->
				<!-- <span v-else>{{ number }}</span> -->
				<span class="no-select">{{ number }}</span>
			</div>

			<!-- Labels -->
			<div class="label label-left" :style="{ left: 50/range.length + '%' }">
				<span class="no-select">{{ getText(textLeft) }}</span>
				<div class="label-line"></div>
			</div>
			<div class="label label-center" :style="{ left: '50%' }">
				<span class="no-select">{{ getText(textCenter) }}</span>
				<div class="label-line"></div>
			</div>
			<div class="label label-right" :style="{ right: 50/range.length + '%' }">
				<span class="no-select">{{ getText(textRight) }}</span>
				<div class="label-line"></div>
			</div>
		</div>
	</div>
</template>



<script>
export default {
	props: [ "min", "max", "textQuestion", "textLeft", "textCenter", "textRight" ],
	data() {
		return {
			selected: null,
		};
	},
	methods: {
		reset(value) {
			this.selected = value || null;
			this.$emit("select", this.selected);
		}
	},
	computed: {
		range() {
			let range = [];
			for (let i = this.min; i <= this.max; i++) {
				range.push(i);
			}
			return range;
		},

		filled() {
			return this.selected != null;
		}
	},
	watch: {
		selected() {
			this.$emit("select", this.selected);
		}
	},
};
</script>



<style scoped>
	.wrapper {
		margin: 1.5rem auto;
		text-align: center;
	}

	.bar {
		position: relative;
		display: flex;
		flex-direction: row;

		margin: 2.5em 0 0 0;
		/*padding: 2em 0 0 0;*/
	}


	.cell {
		-webkit-box-flex: 1;
		-ms-flex: 1 0 0%;
		flex: 1 0 0%;
		transition: all 100ms ease;
		cursor: pointer;

		color: var(--bs-gray-700);
		background: var(--bs-gray-300);
		border: 1px solid var(--bs-gray-700);
		border-right: none;
		padding: 2px;

		text-align: center;
		font-size: 1em;
	}

	.cell-left {
		border-radius: 8px 0 0 8px;
	}
	.cell-right {
		border-radius: 0 8px 8px 0;
		border-right: 1px solid var(--bs-gray-700);
	}

	.cell:hover {
		/*font-weight: bold;*/
		filter: brightness(1.1);
	}
	.cell:active {
		/*font-weight: bold;*/
		filter: brightness(0.95);
		box-shadow: 2px 4px 5px inset #00000022;
	}
	.cell-highlighted {
		background: #ffe491;
		background: var(--bs-gray-600);
		color: white;
	}
	.cell-selected {
		/*background: #ffe596;*/
		/*background: var(--bs-warning);*/
		background: var(--bs-gray-600);
		color: white;
		box-shadow: 2px 4px 5px inset #00000022;
		/*font-size: 1em;*/
	}


	.label {
		position: absolute;
		top: 0;
		font-size: 0.9em;
		color: var(--bs-gray-600);
		/*line-height: 1em;*/
	}
	.label-left {
		transform: translate(-50%, -100%);
	}
	.label-center {
		left: 50%;
		transform: translate(-50%, -100%);
	}
	.label-right {
		transform: translate(50%, -100%);
	}
	.label-line {
		width: 0px;
		height: .5em;
		/*border-right: 1px solid var(--bs-gray-700);*/
		margin: auto;
	}
</style>
